import React from 'react';
import { Icon } from './Icon.js';
export const IconStackFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { x: ".5", width: "8.5", height: "12", rx: "2.25", ry: "2.25", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m11.25,10c-.414,0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v6.5c0,.414-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconStackFill12.js.map